export const blockStyles = {
    position: 'relative',
    width: '800px',
    height: 'auto',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}

export const mockStyles = {
    position: 'relative',
    width: '65%',
    height: '40%',
    maxHeight: 1250,
    zIndex: 2,
    pointerEvents: 'none',
    lineHeight: 'none',
    display: 'inherit'
}

export const boxFrameStyles = {
    position: 'absolute',
    width: '42%',
    height: '86%',
    overflow: 'hidden',
    borderRadius: '30px'
}
export const iframeStyles = {
    width: '100%',
    height: '100%',
    border: 'none',
    zIndex: 1,
    WebkitOverflowScrolling: 'touch'
}